import React, {
  forwardRef,
  useCallback,
  useContext,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import GlobalContext from "../../framework/GlobalContext";
import SelectInput from "../../framework/SelectInput";
import TextInput from "../../framework/TextInput";
import { fetchAdminUsers } from "../../services/user-service";
import classes from "./index.module.css";
const ChangePassword = forwardRef((props, ref) => {
  const inital_state = {
    user: null,
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  };
  const [formState, setFormState] = useState(inital_state);
  const [userList, setUserList] = useState([]);

  const { setCurrentComponent } = useContext(GlobalContext);

  const getUserList = useCallback(async () => {
    const response = await fetchAdminUsers();
    if (response?.status === "success") {
      setUserList(response?.result);
    }
  }, []);

  useImperativeHandle(
    ref,
    () => ({
      getFormState: () => formState,
    }),
    [formState]
  );

  useEffect(() => {
    getUserList();
  }, [getUserList]);

  useEffect(() => {
    setCurrentComponent("change_password_user");
  }, [setCurrentComponent]);

  return (
    <div className={classes["change-password-container"]}>
      <SelectInput
        id="change_password_user"
        label="Select User"
        options={userList}
        getOptionLabel={(option) => option?.username}
        isOptionEqualToValue={(option, value) => option?._id === value?._id}
        onFocus={() => setCurrentComponent("change_password_user")}
        value={formState?.user}
        onChange={(e, value) => {
          setFormState((prev) => {
            return {
              ...prev,
              user: value,
            };
          });
        }}
        markers={JSON.stringify({
          up: "change_password_user",
          down: "change_password_current_password",
          right: "change_password_current_password",
          left: "change_password_user",
        })}
        autoFocus
      />
      <TextInput
        id="change_password_current_password"
        label="Current Password"
        type="password"
        value={formState?.currentPassword}
        onChange={(e) => {
          setFormState((prev) => {
            return {
              ...prev,
              currentPassword: e.target.value,
            };
          });
        }}
        onFocus={() => setCurrentComponent("change_password_current_password")}
        inputProps={{
          "data-markers": JSON.stringify({
            up: "change_password_user",
            down: "change_password_new_password",
            right: "change_password_new_password",
            left: "change_password_user",
          }),
        }}
      />
      <TextInput
        id="change_password_new_password"
        label="New Password"
        type="password"
        value={formState?.newPassword}
        onChange={(e) => {
          setFormState((prev) => {
            return {
              ...prev,
              newPassword: e.target.value,
            };
          });
        }}
        onFocus={() => setCurrentComponent("change_password_new_password")}
        inputProps={{
          "data-markers": JSON.stringify({
            up: "change_password_current_password",
            down: "change_password_confirm_password",
            right: "change_password_confirm_password",
            left: "change_password_current_password",
          }),
        }}
      />
      <TextInput
        id="change_password_confirm_password"
        label="Confirm Password"
        type="password"
        value={formState?.confirmPassword}
        onChange={(e) => {
          setFormState((prev) => {
            return {
              ...prev,
              confirmPassword: e.target.value,
            };
          });
        }}
        onFocus={() => setCurrentComponent("change_password_confirm_password")}
        inputProps={{
          "data-markers": JSON.stringify({
            up: "change_password_new_password",
            down: "change_password_confirm_password",
            right: "change_password_confirm_password",
            left: "change_password_new_password",
          }),
        }}
      />
    </div>
  );
});

export default ChangePassword;
